import _toConsumableArray from "/var/www/pontevedra4picosroad.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export var createModule = function createModule(name, component) {
  return {
    name: name,
    component: component
  };
};
export var createNode = function createNode(module, children) {
  return {
    module: module,
    children: children
  };
};
var traverseNode = function traverseNode(node, target, apply) {
  if (node.module.name === target) {
    return apply(node);
  }
  if (node.children) {
    return [createNode(node.module, node.children.flatMap(function (n) {
      var _a;
      return (_a = traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
    }))];
  }
  return [node];
};
var traverse = function traverse(nodes, target, apply) {
  return nodes.flatMap(function (node) {
    var _a;
    return (_a = traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
  });
};
export var withPlugins = function withPlugins(root, plugins) {
  var config = root;
  var augmentations = [];
  var contains = function contains(target) {
    var nodes = _toConsumableArray(config);
    while (nodes.length > 0) {
      var node = nodes.pop();
      if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
      if (node === null || node === void 0 ? void 0 : node.children) nodes.push.apply(nodes, _toConsumableArray(node.children));
    }
    return false;
  };
  var addParent = function addParent(target, module) {
    if (target === "") {
      config = [createNode(module, config)];
      return;
    }
    config = traverse(config, target, function (node) {
      return [createNode(module, [node])];
    });
  };
  var append = function append(target, module) {
    config = traverse(config, target, function (node) {
      return [createNode(node.module, [createNode(module, node.children)])];
    });
  };
  var addChild = function addChild(target, module, precede) {
    config = traverse(config, target, function (node) {
      var _a;
      return [createNode(node.module, [].concat(_toConsumableArray(precede ? [createNode(module)] : []), _toConsumableArray((_a = node.children) !== null && _a !== void 0 ? _a : []), _toConsumableArray(!precede ? [createNode(module)] : [])))];
    });
  };
  var addSibling = function addSibling(target, module, precede) {
    config = traverse(config, target, function (node) {
      return [].concat(_toConsumableArray(precede ? [createNode(module)] : []), [node], _toConsumableArray(!precede ? [createNode(module)] : []));
    });
  };
  var replace = function replace(target, module) {
    config = traverse(config, target, function (node) {
      return [createNode(module, node.children)];
    });
  };
  var remove = function remove(target) {
    config = traverse(config, target, function (node) {
      return node.children;
    });
  };
  var augment = function augment(augmentation) {
    augmentations.push(augmentation);
  };
  plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
    plugin({
      contains: contains,
      addParent: addParent,
      append: append,
      addChild: addChild,
      addSibling: addSibling,
      replace: replace,
      remove: remove,
      augment: augment
    });
  });
  return {
    config: config,
    augmentation: function augmentation(props) {
      return augmentations.reduce(function (acc, augmentation) {
        return augmentation(acc);
      }, props);
    }
  };
};